import * as React from "react"

import { cn } from "@/lib/utils"
import {
  EMAIL_INPUT_PATTERN,
  formatRussianPhone,
  RUSSIAN_PHONE_PATTERN,
} from "@/lib/forms/contact-validation"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onChange, pattern, inputMode, maxLength, autoComplete, ...props }, ref) => {
    const fieldName = String(props.name || props.id || '').toLowerCase()
    const isPhone = type === 'tel' || fieldName.includes('phone')
    const isEmail = type === 'email' || fieldName.includes('email')

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (isPhone) {
        event.currentTarget.value = formatRussianPhone(event.currentTarget.value)
      }
      onChange?.(event)
    }

    return (
      <input
        type={isPhone ? 'tel' : (isEmail ? 'email' : type)}
        inputMode={inputMode || (isPhone ? 'tel' : (isEmail ? 'email' : undefined))}
        autoComplete={autoComplete || (isPhone ? 'tel' : (isEmail ? 'email' : undefined))}
        pattern={pattern || (isPhone ? RUSSIAN_PHONE_PATTERN : (isEmail ? EMAIL_INPUT_PATTERN : undefined))}
        maxLength={maxLength || (isPhone ? 18 : undefined)}
        title={props.title || (isPhone ? 'Введите телефон в формате +7 (999) 123-45-67' : (isEmail ? 'Введите корректный email, например name@example.ru' : undefined))}
        onChange={handleChange}
        className={cn(
          "flex h-9 w-full rounded-md border border-slate-200 bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-slate-950 placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-950 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-slate-800 dark:file:text-slate-50 dark:placeholder:text-slate-400 dark:focus-visible:ring-slate-300",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
